module.exports = function(h, row) {
    if (this.canUpdate && !this.hasFinalized) {
        return (
            <div>
                <button
                    class="md-btn md-flat m-b-sm btn-xs text-muted"
                    onClick={() => {
                        this.removeCountedStock(row.stock_id);
                    }}
                    type="button"
                >
                    <i class="material-icons">delete</i>
                </button>
            </div>
        );
    }

    return '';
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/stock_check/counted-stock-columns/action.jsx